/*
    @module ActionProvider
    Action provider register
 */
define('shared/util/registers/ActionProvider',[
    '$',
    './Registrable', 
    'shared/lib/ctor', 
    'shared/lib/Emitter', 
    'shared/lib/RSVP',
    'shared/lib/console', 
    'shared/util/hub'
], function ( $, Base, ctor, emitter, RSVP, console, hub) {
    'use strict';

    var KEY_PROVIDER_REGISTER = 'provider.action.register';

    /*
        Mechanism of sub provider automatically registeration:

        subProvider.$el.triggeer('provider.action.register') ->
        bubbling up to dom tree ->
        caught by element who has '[data-action-provider-container]' attribute ->
        store subProvider on hub ->
        wake up container's pending hook on hub ->
        containerProvider links itself to subProvider

    */
    function initContainerObserver() {
        $('html')
        .on(KEY_PROVIDER_REGISTER, '[data-action-provider-container]', function(evt, provider){
            var $currentTarget = $(evt.currentTarget);
            var id = $currentTarget.attr('id');
            var providers;

            if ( id == null || id == '' ) {
                return;
            }

            var path = 'actionProvider/containers/' + id;

            RSVP.resolve()
                .then(function(){
                    var value = hub.peek(path);
                    
                    if ( value != null ) {
                        providers = value;
                        return RSVP.resolve();
                    }
                    else {
                        providers = [];
                        return hub.set(path, providers);
                    }
                })
                .then(function(){
                    providers.push(provider);
                    hub.emit(path + '/add', provider);
                });
        });
    }

    function push ( item ) {
        this.emit('add', item);
        return Array.prototype.push.call(this, item);
    }

    function unshift ( item ) {
        this.emit('add', item);
        return Array.prototype.unshift.call(this, item);
    }

    function pop ( item ) {
        this.emit('remove', item);
        return Array.prototype.pop.call(this, item);
    }

    function shift ( item ) {
        this.emit('remove', item);
        return Array.prototype.shift.call(this, item);
    }

    function splice ( index, length ) {
        for(var i = 0; i < length; i++) {
            this.emit('remove', this[index + i]);
        }
        return Array.prototype.splice.call(this, index, length);
    }

    function extendArrayEvents ( arr ) {
        if ( arr == null ) {
            arr = [];
        } 
        if ( arr.push != push ) {
            emitter(arr);
            arr.unshift = unshift;
            arr.push = push;
            arr.shift = shift;
            arr.pop = pop;
            arr.splice = splice;
        }
        return arr;
    }

    var Ctor = ctor(function () {
        initContainerObserver.call(this);
    }).inherit(Base);

    Ctor.extendArrayEvents = extendArrayEvents;

    var p = Ctor.prototype;

    p.get = function( id, action ){
        return Base.prototype.get.apply(this, arguments)
            .then(function( entity ){
                if ( action == null ) {
                    return entity;
                }

                return new RSVP.Promise(function(resolve){
                    var resolved = false;
                    var timeout = 1000 * 20;
                    
                    setTimeout(function(){
                        if (resolved) {
                            return;
                        }

                        console.warn('Its been', 
                            timeout, 
                            'seconds since it started waiting for component:', 
                            id, 
                            'but it is yet to arrive. ',
                            'Its very likely that one component\'s action is not configured properly in author.');
                    }, timeout);

                    // wait for the action to be added
                    (function loop() {
                        if ( entity.actions[action] != null ) {
                            resolved = true;
                            resolve( entity );
                            return;
                        }

                        setTimeout(loop, 200);
                    })();
                });
            });
    };

    p.register = function( provider ) {
        var me = this;
        if ( 
            provider == null || 
            provider.actions == null ||
            provider.type == null 
        ) {
            throw new Error('Provider does not have required properties');
        }

        return me.has(provider.id)
            .then(function(hasId){
                if (hasId) {
                    return me.get(provider.id);
                } else {
                    return null;
                }
            })
            .then(function(existingEntry){
                var action;
                if (existingEntry) {
                    for(action in provider.actions) {
                        if (!provider.actions.hasOwnProperty(action)){
                            continue;
                        }

                        if (existingEntry.actions[action]) {
                            provider
                                .actions[action]
                                .triggers = existingEntry.actions[action].triggers;
                        } else {
                            provider
                                .actions[action]
                                .triggers = extendArrayEvents(
                                    provider.actions[action].triggers
                                );
                        }
                    }
                } else {
                    for(action in provider.actions) {
                        if (!provider.actions.hasOwnProperty(action)){
                            continue;
                        }
                        provider.actions[action].triggers = extendArrayEvents( provider.actions[action].triggers );
                    }
                }
                if ( provider.$el && typeof provider.$el.trigger === 'function' ) {
                    provider.$el.trigger(KEY_PROVIDER_REGISTER, provider);
                }
            })
            .then(function(){
                return Base.prototype.register.call(me, provider);
            });
    };

    p.unregister = function () {
        return Base.prototype.unregister.apply(this, arguments);
    };

    p.trigger = function( id, action, param, evt ){
        var me = this;
        me.get(id)
            .then(function(entity){
                entity.actions[action](param, evt);
            });
    };

    /*
        @static instance
        The default instance of action provider.
    */
    Ctor.instance = new Ctor();

    Ctor.helper = {
        registerAction: function (source, eventName, targetId, action, param, paramUrl){
            if (!targetId || !action) {
                return;
            }

            try {
                param = JSON.parse(param);
            }
            catch(ex) {
                if ( typeof param === 'string' && typeof param.indexOf === 'function' ) {
                    if ( param.indexOf('/') === 0 || param.indexOf('http') === 0 ) {
                        param = paramUrl;
                    }
                }
            }

            Ctor.instance.get( targetId, action )
                .then(function( entity ){
                    entity.actions[action].triggers.push( source[0] );
                    if (entity.actions[action].autoEnable !== false && source.attr('data-action-provider-auto-enable') !== 'false') {
                        source.removeAttr('disabled');
                    }
                    source.on(eventName, function ( evt ) {
                        if (source.jquery != null && source.is(':disabled') === true) {
                            return;
                        }
                        Ctor.instance.trigger( targetId, action, param, evt );
                        if (evt != null && typeof evt.preventDefault === 'function') {
                            evt.preventDefault();
                        }
                    });
                });

        }
    };

    return Ctor;
});
